import React from 'react';
import SmartDialog from "../../SmartDialog";
import {Button} from "reactstrap";
import {css} from 'glamor';
import {PaginatedView} from "../../PaginatedView";

const rowStyle = css({
    backgroundColor: '#FFF',
    color: '#000',
    cursor: "pointer",
    '&:hover': {
        backgroundColor: 'rgba(50,163,1,0.27)',
        color: '#000'
    }
});

const highlightStyle = css({
    backgroundColor: '#000',
    color: '#FFF',
    cursor: "pointer",
   '&:hover': {
        backgroundColor: '#343434',
        color: 'white'
   }
});

class DropdownList  extends  React.Component {

    constructor(props){
        super(props);
        this.state = DropdownList.getInitialState();
    }

    static getInitialState(state = {}){

        return {
            items: [],
            highlightItem: null,
            highlightItemIndex: -1,
            selectCallback: null,
            title: "Select an item",
            getItemValue: null,
            itemStyle: null,
            ...state
        };

    }

    /**
     * Shows dialog for item selection
     * @param items
     * @param selectCallback
     * @param title
     * @param selected
     * @param getItemValue
     * @param itemStyle
     */
    show({ items , selectCallback , title , selected, getItemValue, itemStyle }){

        this.setState(DropdownList.getInitialState({
            items: items || [],
            selectCallback: selectCallback,
            title: title || "Select an item",
            getItemValue: getItemValue || (item => item.toString()),
            itemStyle: itemStyle || {},
            highlightItem: selected
        }), () => {
            this._dlg.show();
        });

    }

    render(){

        return <SmartDialog ref={r => this._dlg = r} title={this.state.title}>

            <PaginatedView data={this.state.items || []}
                           height={480}
                           emptyMessage="No options are available!"
                           rowHeight={42}
                           onItemClick={(item,index) => {

                               this.setState({
                                   highlightItem: item,
                                   highlightItemIndex: index
                                });

                           }}
                           rowStyle={this.state.itemStyle}
                           renderItem={(item,index) => {
                               const isSelected = this.state.highlightItem === item;
                               return <div className={`${isSelected ? highlightStyle : rowStyle} p-2`}>
                                   <span>{isSelected && <i className="fa fa-check"/>} {this.state.getItemValue(item)}</span>
                               </div>
                           }}>

            </PaginatedView>

            <hr/>
            <div className="clearfix">

                <div className="pull-right">
                    <Button color="green" disabled={this.state.highlightItem === null} onClick={() => {

                        if(this.state.selectCallback)
                            this.state.selectCallback(this.state.highlightItem,this.state.highlightItemIndex);

                        this._dlg.hide();

                    }}><i className="fa fa-check"/> Select</Button>
                </div>

            </div>
        </SmartDialog>
    }

}

export default DropdownList;


// WEBPACK FOOTER //
// ./src/components/CRUDView/Components/DropdownList.js